import React from "react";
// Make sure this path matches exactly where you saved the image
import trustedLogos from "../../assets/trusted&loved.png"; 

export default function TrustedLovedSection() {
  return (
    <section className="bg-[#f8f9fa] py-16 px-6 lg:py-20">
      <div className="mx-auto flex max-w-[1200px] flex-col items-center">
        
        {/* Title */}
        <h2 className="mb-12 text-center text-[28px] font-bold text-[#1a1a1a] sm:text-[32px] md:text-[36px]">
          Trusted and loved by
        </h2>

        {/* Logos Image Container */}
        <div className="flex w-full justify-center">
          <img
            src={trustedLogos}
            alt="Trusted and loved by brands"
            className="w-full max-w-[1000px] object-contain"
          />
        </div>
        
      </div>
    </section>
  );
}